import _ from 'lodash';
import React from 'react';
import {
  CustomerPortalPage,
  CustomerPortalSection,
} from 'api/customer-portal/types';
import { CpWidgetRendererWithDivider } from './cp-widget-renderer-with-divider';

export interface CpSectionRendererProps {
  section: CustomerPortalSection;
  page: CustomerPortalPage;
  projectId: number;
  nextSection?: CustomerPortalSection;
  dontShowDivider?: boolean;
}

export const CpSectionRenderer: React.FC<CpSectionRendererProps> = ({
  section,
  projectId,
  nextSection,
  dontShowDivider,
}) => {
  if (!section) {
    return <></>;
  }

  const { blocks } = section;

  if (!blocks) {
    return <></>;
  }

  const block = blocks.at(0);

  if (!block) {
    return <></>;
  }

  const { widget } = block;

  if (!widget) {
    return <></>;
  }

  if (!widget.widgetType) {
    return <></>;
  }

  return (
    <CpWidgetRendererWithDivider
      projectId={projectId}
      widget={widget}
      nextWidget={nextSection?.blocks?.at(0)?.widget}
      dontShowDivider={dontShowDivider}
    />
  );
};
